<template>
  <div class="fillcontain">
    <head-top></head-top>
    <div class="table_container">
      <el-tabs
        value="first"
        v-model="mediaType"
        @tab-click="handleClick"
        v-if="update"
      >
        <el-tab-pane
          label="网络媒体"
          name="1"
          v-if="onlyRead || mediaType == '1'"
        >
          <div
            class="media-cell cellBox"
            :style="more1 ? 'height: 140px' : 'height: 30px'"
          >
            <p style="height: 40px; width: 85px; float: left">门户类型：</p>
            <el-checkbox-group
              v-model="menhu"
              @change="onCheckbox_menhu"
              style="display: flex; flex-direction: row; flex-wrap: wrap"
            >
              <el-checkbox label="不限" @change="onCheckAll_menhu"
                >不限</el-checkbox
              >
              <el-checkbox label="新浪">新浪</el-checkbox>
              <el-checkbox label="腾讯">腾讯</el-checkbox>
              <el-checkbox label="网易">网易</el-checkbox>
              <el-checkbox label="搜狐">搜狐</el-checkbox>
              <el-checkbox label="中国网">中国网</el-checkbox>
              <el-checkbox label="中国经济网">中国经济网</el-checkbox>
              <el-checkbox label="人民网">人民网</el-checkbox>
              <el-checkbox label="新华网">新华网</el-checkbox>
              <el-checkbox label="光明网">光明网</el-checkbox>
              <el-checkbox label="中国日报网">中国日报网</el-checkbox>
              <el-checkbox label="国际在线">国际在线</el-checkbox>
              <el-checkbox label="央视网">央视网</el-checkbox>
              <el-checkbox label="和讯网">和讯网</el-checkbox>
              <el-checkbox label="中华网">中华网</el-checkbox>
              <el-checkbox label="北青网">北青网</el-checkbox>
              <el-checkbox label="环球网">环球网</el-checkbox>
              <el-checkbox label="中国青年网">中国青年网</el-checkbox>
              <el-checkbox label="中国新闻网">中国新闻网</el-checkbox>
              <el-checkbox label="南方网">南方网</el-checkbox>
              <el-checkbox label="北方网">北方网</el-checkbox>
              <el-checkbox label="慧聪网">慧聪网</el-checkbox>
              <el-checkbox label="大众网">大众网</el-checkbox>
              <el-checkbox label="央视网">央视网</el-checkbox>
              <el-checkbox label="东方网">东方网</el-checkbox>
              <el-checkbox label="央广网">央广网</el-checkbox>
              <el-checkbox label="千龙网">千龙网</el-checkbox>
              <el-checkbox label="中国经济网">中国经济网</el-checkbox>
              <el-checkbox label="海外网">海外网</el-checkbox>
              <el-checkbox label="中青在线">中青在线</el-checkbox>
              <el-checkbox label="非门户">非门户</el-checkbox>
              <el-checkbox label="其他门户">其他门户</el-checkbox>
            </el-checkbox-group>
            <div class="moreBox" v-if="!more1" @click="more1 = true">更多</div>
          </div>
          <div
            class="media-cell cellBox"
            :style="more2 ? 'height: 95px' : 'height: 30px'"
          >
            <p style="height: 94px; width: 85px; float: left">频道类型：</p>
            <el-checkbox-group
              v-model="pindao"
              @change="onCheckbox_pindao"
              style="display: flex; flex-direction: row; flex-wrap: wrap"
            >
              <el-checkbox label="不限" @change="onCheckAll_pindao"
                >不限</el-checkbox
              >
              <el-checkbox label="新闻资讯">新闻资讯</el-checkbox>
              <el-checkbox label="金融财经">金融财经</el-checkbox>
              <el-checkbox label="IT科技">IT科技</el-checkbox>
              <el-checkbox label="房产家居">房产家居</el-checkbox>
              <el-checkbox label="娱乐">娱乐</el-checkbox>
              <el-checkbox label="女性时尚">女性时尚</el-checkbox>
              <el-checkbox label="生活消费">生活消费</el-checkbox>
              <el-checkbox label="游戏动漫">游戏动漫</el-checkbox>
              <el-checkbox label="汽车">汽车</el-checkbox>
              <el-checkbox label="医疗健康">医疗健康</el-checkbox>
              <el-checkbox label="体育">体育</el-checkbox>
              <el-checkbox label="亲子母婴">亲子母婴</el-checkbox>
              <el-checkbox label="教育">教育</el-checkbox>
              <el-checkbox label="区块链">区块链</el-checkbox>
              <el-checkbox label="艺术文化">艺术文化</el-checkbox>
              <el-checkbox label="餐饮食品">餐饮食品</el-checkbox>
              <el-checkbox label="酒店旅游">酒店旅游</el-checkbox>
              <el-checkbox label="商业资讯">商业资讯</el-checkbox>
              <el-checkbox label="法制舆情">法制舆情</el-checkbox>
              <el-checkbox label="农业园艺">农业园艺</el-checkbox>
              <el-checkbox label="慈善公益">慈善公益</el-checkbox>
              <el-checkbox label="电商物流">电商物流</el-checkbox>
              <el-checkbox label="区块链">区块链</el-checkbox>
              <el-checkbox label="其他">其他</el-checkbox>
            </el-checkbox-group>
            <div class="moreBox" v-if="!more2" @click="more2 = true">更多</div>
          </div>
          <div
            class="media-cell"
            style="height: 48px; line-height: 30px; overflow: hidden"
          >
            <p style="height: 48px; width: 85px; float: left">所属区域：</p>
            <el-radio v-model="quyu" @change="city = ''" label="不限"
              >全国</el-radio
            >
            <el-radio v-model="quyu" @change="city = ''" label="北京"
              >北京</el-radio
            >
            <el-radio v-model="quyu" @change="city = ''" label="上海"
              >上海</el-radio
            >
            <el-radio v-model="quyu" @change="city = ''" label="广东"
              >广东</el-radio
            >
            <el-radio v-model="quyu" @change="city = ''" label="天津"
              >天津</el-radio
            >
            <el-radio v-model="quyu" @change="city = ''" label="重庆"
              >重庆</el-radio
            >
            <el-radio v-model="quyu" @change="city = ''" label="海外"
              >海外</el-radio
            >
            <el-cascader
              v-model="city"
              :options="cityList"
              :props="{ value: 'label', checkStrictly: true }"
              separator="-"
              filterable
              clearable
              @change="choseCity"
            ></el-cascader>
          </div>
          <div class="media-cell">
            收录效果：
            <el-radio v-model="shoulu" label="不限">不限</el-radio>
            <el-radio v-model="shoulu" label="包网页收录">包网页收录</el-radio>
            <el-radio v-model="shoulu" label="网页收录">网页收录</el-radio>
            <el-radio v-model="shoulu" label="百度新闻源收录"
              >百度新闻源收录</el-radio
            >
            <el-radio v-model="shoulu" label="包百度新闻收录"
              >包百度新闻收录</el-radio
            >
          </div>
          <div class="media-cell">
            投放类型：
            <el-radio v-model="toufang" label="">不限</el-radio>
            <el-radio v-model="toufang" label="转载">转载</el-radio>
            <el-radio v-model="toufang" label="首发">首发</el-radio>
            <el-radio v-model="toufang" label="焦点图">焦点图</el-radio>
            <el-radio v-model="toufang" label="文字链">文字链</el-radio>
          </div>
          <div class="media-cell">
            价格区间：
            <el-radio v-model="jiage" label="0-999999">不限</el-radio>
            <el-radio v-model="jiage" label="0-20">0-20</el-radio>
            <el-radio v-model="jiage" label="21-50">21-50</el-radio>
            <el-radio v-model="jiage" label="51-75">51-75</el-radio>
            <el-radio v-model="jiage" label="76-100">76-100</el-radio>
            <el-radio v-model="jiage" label="100-999999">100以上</el-radio>
          </div>
          <div class="media-cell">
            平台认证：
            <el-radio v-model="isAuth" label="0">不限</el-radio>
            <el-radio v-model="isAuth" label="1">已认证</el-radio>
            <el-radio v-model="isAuth" label="2">未认证</el-radio>
          </div>
          <div class="media-cell">
            其他选项：
            <el-radio v-model="other" label="">不限</el-radio>
            <el-radio v-model="other" label="周末可发">周末可发</el-radio>
            <el-radio v-model="other" label="秒发">秒发</el-radio>
            <el-radio v-model="other" label="节假日可发">节假日可发</el-radio>
            <el-radio v-model="other" label="可发视频">可发视频</el-radio>
            <el-radio v-model="other" label="可带超链">可带超链</el-radio>
          </div>
          <div class="tipsBox">{{ tips }}</div>
          <div class="media-cell" style="height: 60px; line-height: 50px">
            媒体名称：
            <div class="media-input">
              <el-input
                v-model="sousuo"
                @keyup.enter.native="search(1)"
                placeholder="请输入媒体编号或名称"
              >
              </el-input>
            </div>
            <p class="media-p1">可发内链</p>
            <div class="media-select">
              <el-select v-model="value" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <p class="media-p2">可发联系方式</p>
            <div class="media-select2">
              <el-select v-model="value2" placeholder="请选择">
                <el-option
                  v-for="item in options2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="media-p3">
              <el-button type="primary" @click="search(1)">搜索</el-button>
              <el-button
                :loading="downloadLoading"
                @click="onExpout"
                >导出资源</el-button
              >
              <!-- <el-button type="button" @click="resh">重置</el-button> -->
            </div>
          </div>
          <el-table
            ref="multipleTable"
            :data="tableData"
            highlight-current-row
            style="width: 100%"
            v-loading="loading"
            @selection-change="handleSelectionChange"
            row-key="id"
          >
            <el-table-column width="50%">
              <template slot-scope="scope">
                <i
                  class="el-icon-circle-plus-outline"
                  style="cursor: pointer"
                  @click="
                    addcar(
                      scope.row,
                      'price',
                      scope.row.price,
                      scope.row.addPrice,
                      scope.row.disPrice
                    )
                  "
                ></i>
              </template>
            </el-table-column>
            <el-table-column label="媒体名称" width="95%">
              <template slot-scope="scope">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  :href="scope.row.mediaCase"
                  >{{ scope.row.name }}</a
                >
              </template>
            </el-table-column>
            <el-table-column property="price" label="价格" width="80%">
              <template slot-scope="scope">
                <a>{{ scope.row.price + scope.row.addPrice }}</a>
              </template>
            </el-table-column>
            <el-table-column
              property="channel"
              label="频道类型"
              width="80%"
            ></el-table-column>
            <el-table-column
              property="area"
              label="地区"
              width="80%"
            ></el-table-column>
            <el-table-column
              property="linkable"
              label="是否带链接"
              width="90%"
            ></el-table-column>
            <el-table-column
              property="contactable"
              label="带联系方式"
              width="90%"
            ></el-table-column>
            <el-table-column
              property="rate"
              label="出稿率"
              width="80%"
            ></el-table-column>
            <el-table-column
              property="speed"
              label="出稿速度"
              width="80%"
            ></el-table-column>
            <el-table-column
              property="included"
              label="收录类型"
              width="80%"
            ></el-table-column>
            <el-table-column property="auth" label="是否认证" width="80%">
              <template slot-scope="scope">
                <a v-if="scope.row.auth == '已认证'" class="yrz">
                  {{ scope.row.auth }}
                </a>
                <a v-else class="wrz">{{ scope.row.auth }}</a>
              </template>
            </el-table-column>
            <el-table-column property="remark" label="备注">
              <template slot-scope="scope">
                <el-popover
                  placement="top-start"
                  width="360"
                  trigger="hover"
                  :content="scope.row.remark"
                >
                  <p class="over_text" slot="reference">
                    {{ scope.row.remark }}
                  </p>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
          <div class="Pagination" style="text-align: left; margin-top: 10px">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="index"
              :page-size="10"
              layout="total, prev, pager, next"
              :total="count"
            >
            </el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="自媒体"
          name="2"
          v-if="onlyRead || mediaType == '2'"
        >
          <div
            class="media-cell cellBox"
            :style="more3 ? 'height: 140px' : 'height: 30px'"
          >
            <p style="height: 140px; width: 85px; float: left">所属平台：</p>
            <el-checkbox-group v-model="menhu2" @change="onCheckbox_menhu2">
              <el-checkbox label="不限" @change="onCheckAll_menhu2"
                >不限</el-checkbox
              >
              <el-checkbox label="今日头条">今日头条</el-checkbox>
              <el-checkbox label="百度百家">百度百家</el-checkbox>
              <el-checkbox label="网易号">网易号</el-checkbox>
              <el-checkbox label="腾讯号">腾讯号</el-checkbox>
              <el-checkbox label="新浪头条">新浪头条</el-checkbox>
              <el-checkbox label="搜狐头条">搜狐头条</el-checkbox>
              <el-checkbox label="雪球号">雪球号</el-checkbox>
              <el-checkbox label="一点资讯">一点资讯</el-checkbox>
              <el-checkbox label="UC头条">UC头条</el-checkbox>
              <el-checkbox label="凤凰号">凤凰号</el-checkbox>
              <el-checkbox label="知乎号">知乎号</el-checkbox>
              <el-checkbox label="小红书">小红书</el-checkbox>
              <el-checkbox label="简书">简书</el-checkbox>
              <el-checkbox label="东方财富号">东方财富号</el-checkbox>
              <el-checkbox label="同花顺">同花顺</el-checkbox>
              <el-checkbox label="人民全国">人民全国</el-checkbox>
              <el-checkbox label="人民号">人民号</el-checkbox>
              <el-checkbox label="新华客户端">新华客户端</el-checkbox>
              <el-checkbox label="东方头条">东方头条</el-checkbox>
              <el-checkbox label="搜狐焦点家居">搜狐焦点家居</el-checkbox>
              <el-checkbox label="UC头条">UC头条</el-checkbox>
              <el-checkbox label="东方头条">东方头条</el-checkbox>
              <el-checkbox label="马蜂窝">马蜂窝</el-checkbox>
              <el-checkbox label="驴妈妈">驴妈妈</el-checkbox>
              <el-checkbox label="去哪儿">去哪儿</el-checkbox>
              <el-checkbox label="爱奇艺">爱奇艺</el-checkbox>
              <el-checkbox label="懂车帝">懂车帝</el-checkbox>
              <el-checkbox label="其他">其他</el-checkbox>
            </el-checkbox-group>
            <div class="moreBox" v-if="!more3" @click="more3 = true">更多</div>
          </div>
          <div
            class="media-cell cellBox"
            :style="more4 ? 'height: 106px' : 'height: 30px'"
          >
            <p style="height: 106px; width: 85px; float: left">行业类型：</p>
            <el-checkbox-group v-model="pindao2" @change="onCheckbox_pindao2">
              <el-checkbox label="不限" @change="onCheckAll_pindao2"
                >不限</el-checkbox
              >
              <el-checkbox label="新闻资讯">新闻资讯</el-checkbox>
              <el-checkbox label="财经金融">财经金融</el-checkbox>
              <el-checkbox label="3C科技">3C科技</el-checkbox>
              <el-checkbox label="家居房产">家居房产</el-checkbox>
              <el-checkbox label="女性时尚">女性时尚</el-checkbox>
              <el-checkbox label="母婴亲子">母婴亲子</el-checkbox>
              <el-checkbox label="汽车">汽车</el-checkbox>
              <el-checkbox label="娱乐">娱乐</el-checkbox>
              <el-checkbox label="体育">体育</el-checkbox>
              <el-checkbox label="文化艺术">文化艺术</el-checkbox>
              <el-checkbox label="情感">情感</el-checkbox>
              <el-checkbox label="生活">生活</el-checkbox>
              <el-checkbox label="设计">设计</el-checkbox>
              <el-checkbox label="商业">商业</el-checkbox>
              <el-checkbox label="医疗健康">医疗健康</el-checkbox>
              <el-checkbox label="电商物流">电商物流</el-checkbox>
              <el-checkbox label="教育培训">教育培训</el-checkbox>
              <el-checkbox label="食品餐饮">食品餐饮</el-checkbox>
              <el-checkbox label="企业服务">企业服务</el-checkbox>
              <el-checkbox label="其他">其他</el-checkbox>
            </el-checkbox-group>
            <div class="moreBox" v-if="!more4" @click="more4 = true">更多</div>
          </div>
          <div
            class="media-cell"
            style="height: 48px; line-height: 30px; overflow: hidden"
          >
            <p style="height: 48px; width: 85px; float: left">所属区域：</p>
            <el-radio v-model="zqy" @change="city2 = ''" label="不限"
              >全国</el-radio
            >
            <el-radio v-model="zqy" @change="city2 = ''" label="北京"
              >北京</el-radio
            >
            <el-radio v-model="zqy" @change="city2 = ''" label="上海"
              >上海</el-radio
            >
            <el-radio v-model="zqy" @change="city2 = ''" label="广东"
              >广东</el-radio
            >
            <el-radio v-model="zqy" @change="city2 = ''" label="天津"
              >天津</el-radio
            >
            <el-radio v-model="zqy" @change="city2 = ''" label="重庆"
              >重庆</el-radio
            >
            <el-radio v-model="zqy" @change="city2 = ''" label="海外"
              >海外</el-radio
            >
            <el-cascader
              v-model="city2"
              :options="cityList"
              :props="{ value: 'label', checkStrictly: true }"
              separator="-"
              filterable
              clearable
              @change="choseCity2"
            ></el-cascader>
          </div>
          <div class="media-cell">
            参考粉丝量：
            <el-radio v-model="quyu2" label="0-9999999">不限</el-radio>
            <el-radio v-model="quyu2" label="0-10000">一万以下</el-radio>
            <el-radio v-model="quyu2" label="10000-50000">1-5万</el-radio>
            <el-radio v-model="quyu2" label="50000-200000">5-20万</el-radio>
            <el-radio v-model="quyu2" label="200000-500000">20-50万</el-radio>
            <el-radio v-model="quyu2" label="500000-1000000">50-100万</el-radio>
            <el-radio v-model="quyu2" label="1000000-5000000"
              >100-500万</el-radio
            >
            <el-radio v-model="quyu2" label="5000000-9999999"
              >500万以上</el-radio
            >
          </div>
          <div class="media-cell">
            参考阅读量：
            <el-radio v-model="shoulu2" label="0-999999">不限</el-radio>
            <el-radio v-model="shoulu2" label="0-1000">1000以下</el-radio>
            <el-radio v-model="shoulu2" label="1000-5000">1000-5000</el-radio>
            <el-radio v-model="shoulu2" label="5000-10000">5000-1万</el-radio>
            <el-radio v-model="shoulu2" label="10000-50000">1万-5万</el-radio>
            <el-radio v-model="shoulu2" label="50000-100000">5万-10万</el-radio>
            <el-radio v-model="shoulu2" label="100000-999999"
              >10万以上</el-radio
            >
          </div>
          <div class="media-cell">
            <p style="height: 40px; width: 85px; float: left">媒体类型：</p>
            <el-checkbox-group v-model="toufang2" @change="onCheckbox_toufang2">
              <el-checkbox label="不限" @change="onCheckAll_toufang2"
                >不限</el-checkbox
              >
              <el-checkbox label="官方网媒认证">官方网媒认证</el-checkbox>
              <el-checkbox label="个人认证">个人认证</el-checkbox>
              <el-checkbox label="未认证">未认证</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="media-cell">
            价格区间：
            <el-radio v-model="jiage2" label="0-999999">不限</el-radio>
            <el-radio v-model="jiage2" label="0-20">0-20</el-radio>
            <el-radio v-model="jiage2" label="20-100">20-100</el-radio>
            <el-radio v-model="jiage2" label="100-500">100-500</el-radio>
            <el-radio v-model="jiage2" label="500-1000">500-1000</el-radio>
            <el-radio v-model="jiage2" label="1000-2000">1000-2000</el-radio>
            <el-radio v-model="jiage2" label="2000-5000">2000-5000</el-radio>
            <el-radio v-model="jiage2" label="5000-10000">5000-10000</el-radio>
            <el-radio v-model="jiage2" label="10000-999999">10000以上</el-radio>
          </div>
          <div class="media-cell">
            平台认证：
            <el-radio v-model="isAuth2" label="0">不限</el-radio>
            <el-radio v-model="isAuth2" label="1">已认证</el-radio>
            <el-radio v-model="isAuth2" label="2">未认证</el-radio>
          </div>
          <div class="media-cell">
            <p style="height: 40px; width: 85px; float: left">其他选项：</p>
            <el-checkbox-group v-model="other2" @change="onCheckbox_other2">
              <el-checkbox label="不限" @change="onCheckAll_other2"
                >不限</el-checkbox
              >
              <el-checkbox label="周末可发">周末可发</el-checkbox>
              <el-checkbox label="秒发">秒发</el-checkbox>
              <el-checkbox label="节假日可发">节假日可发</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="tipsBox">{{ tips2 }}</div>
          <div class="media-cell" style="height: 60px; line-height: 50px">
            媒体名称：
            <div class="media-input">
              <el-input
                v-model="sousuo2"
                @keyup.enter.native="search2(1)"
                placeholder="请输入媒体编号或名称"
              >
              </el-input>
            </div>
            <p class="media-p1">可发内链</p>
            <div class="media-select">
              <el-select v-model="value_2" placeholder="请选择">
                <el-option
                  v-for="item in options_2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <p class="media-p2">可发联系方式</p>
            <div class="media-select2">
              <el-select v-model="value2_2" placeholder="请选择">
                <el-option
                  v-for="item in options2_2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="media-p3">
              <el-button type="primary" @click="search2(1)">搜索</el-button>
              <el-button
        :loading="downloadLoading"
        @click="onExpout2"
        >导出资源</el-button
      >
            </div>
          </div>
          <el-table
            :data="tableData2"
            highlight-current-row
            style="width: 100%"
            v-loading="loading"
            @selection-change="handleSelectionChange"
          >
            <el-table-column width="50%">
              <template slot-scope="scope">
                <i
                  class="el-icon-circle-plus-outline"
                  style="cursor: pointer"
                  @click="
                    addcar(
                      scope.row,
                      'price',
                      scope.row.price,
                      scope.row.addPrice,
                      scope.row.disPrice
                    )
                  "
                ></i>
              </template>
            </el-table-column>
            <el-table-column label="媒体名称" width="95%">
              <template slot-scope="scope">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  :href="scope.row.mediaCase"
                  >{{ scope.row.name }}</a
                >
              </template>
            </el-table-column>
            <el-table-column property="price" label="价格" width="80%">
              <template slot-scope="scope">
                <a>{{ scope.row.price + scope.row.addPrice }}</a>
              </template>
            </el-table-column>
            <el-table-column
              property="portal"
              label="平台"
              width="80%"
            ></el-table-column>
            <el-table-column
              property="channel"
              label="行业"
              width="80%"
            ></el-table-column>
            <el-table-column
              property="linkable"
              label="是否带链接"
              width="90%"
            ></el-table-column>
            <el-table-column
              property="contactable"
              label="带联系方式"
              width="90%"
            ></el-table-column>
            <el-table-column
              property="rate"
              label="出稿率"
              width="80%"
            ></el-table-column>
            <el-table-column
              property="speed"
              label="出稿速度"
              width="80%"
            ></el-table-column>
            <el-table-column
              property="fans"
              label="粉丝数"
              width="80%"
            ></el-table-column>
            <el-table-column
              property="area"
              label="地区"
              width="80%"
            ></el-table-column>
            <el-table-column
              property="included"
              label="参考阅读量"
              width="80%"
            ></el-table-column>
            <el-table-column property="auth" label="是否认证" width="80%">
              <template slot-scope="scope">
                <a v-if="scope.row.auth == '已认证'" class="yrz">
                  {{ scope.row.auth }}
                </a>
                <a v-else class="wrz">{{ scope.row.auth }}</a>
              </template>
            </el-table-column>
            <el-table-column property="remark" label="备注">
              <template slot-scope="scope">
                <el-popover
                  placement="top-start"
                  width="360"
                  trigger="hover"
                  :content="scope.row.remark"
                >
                  <p class="over_text" slot="reference">
                    {{ scope.row.remark }}
                  </p>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
          <div class="Pagination" style="text-align: left; margin-top: 10px">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange2"
              :current-page="index2"
              :page-size="10"
              layout="total, prev, pager, next"
              :total="count2"
            >
            </el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="微信公众号"
          name="3"
          v-if="onlyRead || mediaType == '3'"
        >
          <Offical
            ref="Offical"
            v-if="mediaType == '3'"
            @addcar="addcar"
            @handleSelectionChange="handleSelectionChange"
          >
          </Offical>
        </el-tab-pane>
        <el-tab-pane label="微博" name="4" v-if="onlyRead || mediaType == '4'">
          <Bolg
            v-if="mediaType == '4'"
            @addcar="addcar"
            ref="Bolg"
            @handleSelectionChange="handleSelectionChange"
          >
          </Bolg>
        </el-tab-pane>
        <el-tab-pane
          label="百科问答知识营销"
          name="5"
          v-if="onlyRead || mediaType == '5'"
        >
          <Wiki
            ref="Wiki"
            v-if="mediaType == '5'"
            @addcar="addcar"
            @handleSelectionChange="handleSelectionChange"
          >
          </Wiki>
        </el-tab-pane>
        <el-tab-pane
          label="朋友圈社群"
          name="6"
          v-if="onlyRead || mediaType == '6'"
        >
          <Wechat
            ref="Wechat"
            v-if="mediaType == '6'"
            @addcar="addcar"
            @handleSelectionChange="handleSelectionChange"
          >
          </Wechat>
        </el-tab-pane>
        <el-tab-pane
          label="短视频"
          name="7"
          v-if="onlyRead || mediaType == '7'"
        >
          <Tiktok
            ref="Tiktok"
            v-if="mediaType == '7'"
            @addcar="addcar"
            @handleSelectionChange="handleSelectionChange"
          >
          </Tiktok>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div v-if="!onlyRead" ref="addHeight" style="height: 310px"></div>
    <div v-if="!onlyRead" class="choose-bottom" ref="bottoms">
      <a v-for="item in car" :key="item.id">
        <a>
          {{ item.name }}({{ item.price + item.addPrice }})
          <a
            style="
              color: #0054b7;
              font-size: 14pt;
              font-family: 'arial';
              cursor: pointer;
            "
            @click="deltcar(item)"
            >ⓧ</a
          >
          ;
        </a>
      </a>
      <br />
      合计总价：{{ total + total2 }}元 数量：{{ car.length }}
    </div>
    <el-button
      v-if="!onlyRead"
      class="btn_bottom"
      style="right: 160px"
      @click="onBack"
      >上一步</el-button
    >
    <el-button
      v-if="!onlyRead"
      class="btn_bottom"
      :disabled="fagao"
      type="primary"
      @click="placeorder"
      >确定下单
    </el-button>
  </div>
</template>

<script>
import axios from "axios";
import cityList from "../components/city.json";
import myAxios from "../myAxios";
import HeadTop from "../components/HeadTop";
import Offical from "./medias/Offical.vue";
import Bolg from "./medias/Bolg.vue";
import Tiktok from "./medias/Tiktok.vue";
import Wiki from "./medias/Wiki.vue";
import Wechat from "./medias/Wechat.vue";

export default {
  inject: ["reload"],
  watch: {
    $route(to, from) {
      this.reload();
    },
  },
  data() {
    return {
      downloadLoading: false,
      tips: "",
      tips2: "",
      city: "",
      city2: "",
      more1: false,
      more2: false,
      more3: false,
      more4: false,
      update: true,
      mediaType: "1",
      fagao: false,
      car: [],
      oldval: [],
      souOff: false,
      mediaIds: [],
      mediaIds2: [],
      total: 0, //总价
      total2: 0, //总价
      url: localStorage.getItem("url"),
      tableData: [], //用户列表数据
      tableData2: [], //用户列表数据
      index: 1, //页码
      index2: 1, //页码
      size: 10, //页大小
      count: 0, //数据总数
      count2: 0, //数据总数
      loading: false, //加载状态
      menhu: ["不限"],
      pindao: ["不限"],
      quyu: "不限",
      zqy: "不限",
      shoulu: "不限",
      toufang: "",
      toufang2: ["不限"],
      jiage: "0-999999",
      menhu2: ["不限"],
      pindao2: ["不限"],
      quyu2: "0-9999999",
      shoulu2: "0-999999",
      isAuth: "0",
      isAuth2: "0",
      jiage2: "0-999999",
      other: "",
      other2: ["不限"],
      sousuo: "", //媒体名称
      sousuo2: "", //媒体名称
      options: [
        //可发内链
        {
          //选择器1
          value: "",
          label: "请选择",
        },
        {
          value: "是",
          label: "是",
        },
        {
          value: "否",
          label: "否",
        },
      ],
      value: "", //选择器1
      options2: [
        //可发联系方式
        {
          //选择器2
          value: "",
          label: "请选择",
        },
        {
          value: "是",
          label: "是",
        },
        {
          value: "否",
          label: "否",
        },
      ],
      value2: "", //选择器2
      options_2: [
        //可发内链
        {
          //选择器1
          value: "",
          label: "请选择",
        },
        {
          value: "是",
          label: "是",
        },
        {
          value: "否",
          label: "否",
        },
      ],
      value_2: "", //选择器1
      options2_2: [
        //可发联系方式
        {
          //选择器2
          value: "请选择",
          label: "",
        },
        {
          value: "是",
          label: "是",
        },
        {
          value: "否",
          label: "否",
        },
      ],
      value2_2: "", //选择器2
      onlyRead: false,
      cityList: [],
    };
  },
  components: {
    HeadTop,
    Offical,
    Bolg,
    Tiktok,
    Wiki,
    Wechat,
  },
  created() {
    this.getTips();
    // cityList
    this.cityList = cityList;
    if (this.$route.query && this.$route.query.num) {
      this.update = false;
      this.mediaType = this.$route.query.num + "";
      this.update = true;
    }
    if (this.$route.query && this.$route.query.i == "1") {
      this.onlyRead = true;
    }
    if (sessionStorage.getItem("total")) {
      this.total = Number(sessionStorage.getItem("total"));
      sessionStorage.removeItem("total");
    }
    if (sessionStorage.getItem("total2")) {
      this.total2 = Number(sessionStorage.getItem("total2"));
      sessionStorage.removeItem("total2");
    }
    if (sessionStorage.getItem("car")) {
      this.car = JSON.parse(sessionStorage.getItem("car"));
      sessionStorage.removeItem("car");
    }
    if (sessionStorage.getItem("mediaIds")) {
      this.mediaIds = JSON.parse(sessionStorage.getItem("mediaIds"));
      sessionStorage.removeItem("mediaIds");
    }
    this.initData();
  },
  methods: {
    onExpout() {
      this.downloadLoading = true;
      var priceStart = this.jiage.split("-")[0];
      var priceEnd = this.jiage.split("-")[1];
      var quyu = this.quyu;
      if (quyu == "全国") {
        quyu = "";
      }
      var data = {
        username: localStorage.getItem("username"),
        priceStart: priceStart,
        priceEnd: priceEnd,
        fansStart: 0,
        fansEnd: 99999,
        readingStart: 0,
        readingEnd: 99999,
        friendsStart: 0,
        friendsEnd: 99999,
        mediaType: 1,
        index: this.index,
        size: this.count,
        isAuth: this.isAuth,
        portals: this.menhu,
        channels: this.pindao,
        area: quyu,
        included: this.shoulu,
        name: this.sousuo.replace(/\s*/g, ""),
        linkable: this.value,
        contactable: this.value2,
        others: this.other,
        lanuch: this.toufang,
        isAll: true,
      };
      myAxios.post(`/client_user/MediasExport/v1`, data).then((res) => {
        this.downloadLoading = false;
        const link = document.createElement("a");
        link.href = res.data;
        link.setAttribute("download", "导出数据");
        document.body.appendChild(link);
        link.click();
      });
    },
    onExpout2() {
      var priceStart = this.jiage2.split("-")[0];
      var priceEnd = this.jiage2.split("-")[1];
      var fansStart = this.quyu2.split("-")[0];
      var fansEnd = this.quyu2.split("-")[1];
      var readingStart = this.shoulu2.split("-")[0];
      var readingEnd = this.shoulu2.split("-")[1];
      var quyu = this.zqy;
      if (quyu == "全国") {
        quyu = "";
      }
      var data = {
        username: localStorage.getItem("username"),
        mediaType: 2,
        priceStart: priceStart,
        priceEnd: priceEnd,
        fansStart: fansStart,
        fansEnd: fansEnd,
        readingStart: readingStart,
        readingEnd: readingEnd,
        friendsStart: 0,
        friendsEnd: 99999,
        portals: this.menhu2,
        channels: this.pindao2,
        area: quyu,
        name: this.sousuo2.replace(/\s*/g, ""),
        linkable: this.value_2,
        contactable: this.value2_2,
        others: this.other2,
        lanuch: this.toufang2.join("-"),
        index: this.index2,
        size: this.count,
        isAuth: this.isAuth2,
        isAll: true,
      };
      myAxios.post(`/client_user/MediasExport/v1`, data).then((res) => {
        this.downloadLoading = false;
        const link = document.createElement("a");
        link.href = res.data;
        link.setAttribute("download", "导出数据");
        document.body.appendChild(link);
        link.click();
      });
    },
    onExpout3() {
      this.$refs.Offical.onExpout();
    },
    onExpout4() {
      this.$refs.Bolg.onExpout();
    },
    onExpout5() {
      this.$refs.Wiki.onExpout();
    },
    onExpout6() {
      this.$refs.Wechat.onExpout();
    },
    onExpout7() {
      this.$refs.Tiktok.onExpout();
    },
    getTips() {
      myAxios.get(`/key_value/QueryAllValues/v1`).then((res) => {
        var arr = res.data;
        for (var i = 0; i < arr.length; i++) {
          localStorage.setItem(arr[i].key, arr[i].value);
        }
        this.tips = localStorage.getItem("mediaTips");
        this.tips2 = localStorage.getItem("selfTips");
      });
      // http://47.115.92.84:808/api/
    },
    onBack() {
      sessionStorage.setItem("total", this.total);
      sessionStorage.setItem("total2", this.total2);
      sessionStorage.setItem("car", JSON.stringify(this.car));
      sessionStorage.setItem("mediaIds", JSON.stringify(this.mediaIds));
      this.$router.go(-1);
    },
    // 搜索
    search(num) {
      if (num) {
        this.index = 1;
      }
      var priceStart = this.jiage.split("-")[0];
      var priceEnd = this.jiage.split("-")[1];
      var quyu = this.quyu;
      if (quyu == "全国") {
        quyu = "";
      }
      var data = {
        username: localStorage.getItem("username"),
        priceStart: priceStart,
        priceEnd: priceEnd,
        fansStart: 0,
        fansEnd: 99999,
        readingStart: 0,
        readingEnd: 99999,
        friendsStart: 0,
        friendsEnd: 99999,
        mediaType: 1,
        index: this.index,
        size: this.size,
        isAuth: this.isAuth,
        portals: this.menhu,
        channels: this.pindao,
        area: quyu,
        included: this.shoulu,
        name: this.sousuo.replace(/\s*/g, ""),
        linkable: this.value,
        contactable: this.value2,
        others: this.other,
        lanuch: this.toufang,
      };
      myAxios.post(`/client_user/Medias/v1`, data).then((res) => {
        this.tableData = res.data;
        for (var i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].auth) {
            this.tableData[i].auth = "已认证";
          } else {
            this.tableData[i].auth = "未认证";
          }
          if (this.tableData[i].contactable) {
            this.tableData[i].contactable = "是";
          } else {
            this.tableData[i].contactable = "否";
          }
          if (this.tableData[i].linkable) {
            this.tableData[i].linkable = "是";
          } else {
            this.tableData[i].linkable = "否";
          }
        }
        this.count = res.total;
      });
    },
    search2(num) {
      if (num) {
        this.index2 = 1;
      }
      // included: this.shoulu2,
      // priceRange: this.jiage2,
      var priceStart = this.jiage2.split("-")[0];
      var priceEnd = this.jiage2.split("-")[1];
      var fansStart = this.quyu2.split("-")[0];
      var fansEnd = this.quyu2.split("-")[1];
      var readingStart = this.shoulu2.split("-")[0];
      var readingEnd = this.shoulu2.split("-")[1];
      var quyu = this.zqy;
      if (quyu == "全国") {
        quyu = "";
      }
      var data = {
        username: localStorage.getItem("username"),
        mediaType: 2,
        priceStart: priceStart,
        priceEnd: priceEnd,
        fansStart: fansStart,
        fansEnd: fansEnd,
        readingStart: readingStart,
        readingEnd: readingEnd,
        friendsStart: 0,
        friendsEnd: 99999,
        portals: this.menhu2,
        channels: this.pindao2,
        area: quyu,
        name: this.sousuo2.replace(/\s*/g, ""),
        linkable: this.value_2,
        contactable: this.value2_2,
        others: this.other2,
        lanuch: this.toufang2.join("-"),
        index: this.index2,
        size: this.size,
        isAuth: this.isAuth2,
      };
      myAxios.post(`/client_user/Medias/v1`, data).then((res) => {
        this.tableData2 = res.data;
        this.count2 = res.total;
        for (var i = 0; i < this.tableData2.length; i++) {
          if (this.tableData2[i].auth) {
            this.tableData2[i].auth = "已认证";
          } else {
            this.tableData2[i].auth = "未认证";
          }
          if (this.tableData2[i].contactable) {
            this.tableData2[i].contactable = "是";
          } else {
            this.tableData2[i].contactable = "否";
          }
          if (this.tableData2[i].linkable) {
            this.tableData2[i].linkable = "是";
          } else {
            this.tableData2[i].linkable = "否";
          }
        }
      });
    },
    async initData() {
      try {
        this.getUsers();
      } catch (err) {
        console.log("获取数据失败");
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(val);
      this.index = val;
      this.search();
    },
    handleCurrentChange2(val) {
      console.log(val);
      this.index2 = val;
      this.search2();
    },
    addcar(item, str, price, addPrice,disPrice) {
      var val = {
        id: item.id,
        mediaType: item.mediaType,
        priceType: str,
        price: price,
        addPrice: addPrice,
        disPrice:disPrice
      };
      this.$refs.addHeight.style.height =
        this.$refs.bottoms.offsetHeight + "px";
      for (var t = 0; t < this.mediaIds.length; t++) {
        if (this.mediaIds[t].id == val.id) {
          return;
        }
      }
      // alert(this.total +';z'+ price +';z'+ item.addPrice)
      this.total = this.total + price + item.addPrice;
      this.mediaIds.push(val);
      console.log(this.mediaIds);
      this.car.push({
        id: val.id,
        name: item.name,
        price: price,
        addPrice: item.addPrice,
      });
    },
    deltcar(val) {
      for (var i = 0; i < this.car.length; i++) {
        if (this.car[i].id == val.id) {
          this.car.splice(i, 1);
          this.mediaIds.splice(i, 1);
          this.total = this.total - val.price - val.addPrice;
          return;
        }
      }
    },
    choseCity(e) {
      if (e.length > 1) {
        this.quyu = e[1];
      } else {
        this.quyu = e[0];
      }
      console.log(this.quyu);
    },
    choseCity2(e) {
      if (e.length > 1) {
        this.zqy = e[1];
      } else {
        this.zqy = e[0];
      }
      console.log(this.zqy);
    },
    handleSelectionChange(val) {
      // this.$refs.addHeight
      this.oldval = val;
      this.total = 0;
      this.mediaIds = [];
      if (val.length > 0) {
        for (var i = 0; i < val.length; i++) {
          this.total = this.total + val[i].price;
          this.mediaIds.push(val[i].id);
        }
      }
      this.car = "";
      for (var i = 0; i < val.length; i++) {
        this.car = this.car + val[i].name;
        this.car = this.car + " ; ";
      }
      console.log(this.mediaIds);
    },
    handleSelectionChange2(val) {
      console.log(val);
      this.total2 = 0;
      this.mediaIds2 = [];
      if (val.length > 0) {
        for (var i = 0; i < val.length; i++) {
          this.total2 = this.total2 + val[i].price;
          this.mediaIds2.push(val[i].id);
        }
      }
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          console.log(row);
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },

    // 下单
    placeorder(off) {
      let params = true;
      if (off == false) {
        params = false;
      }
      let ha = this.mediaIds;
      var that = this;
      if (this.total == 0) {
        this.$alert("你还没有选择媒体平台", "提示", {
          confirmButtonText: "确定",
        });
        return;
      } else {
        let data = {
          username: localStorage.getItem("username"),
          medias: ha,
          title: localStorage.getItem("title"),
          link: localStorage.getItem("link"),
          content: localStorage.getItem("content"),
          remark: localStorage.getItem("remark"),
          personalRemark: localStorage.getItem("personalReamrk") || "",
          isCheck: params,
          // file: localStorage.getItem("file"),
        };
        this.fagao = true;
        console.log("data", data);
        setTimeout(() => {
          that.fagao = false;
        }, 500);
        // return
        myAxios.post(`/client_user/PublishArticle/v1?`, data).then((res) => {
          if (res.code == 0) {
            if (!res.data.success) {
              this.$confirm(res.data.message, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
                .then(() => {
                  that.placeorder(false);
                  return;
                })
                .catch(() => {});
            } else {
              this.$alert(res.data.message, "提示", {
                confirmButtonText: "确定",
              }).then(() => {
                localStorage.removeItem("title");
                localStorage.removeItem("link");
                localStorage.removeItem("content");
                localStorage.removeItem("remark");
                localStorage.removeItem("personalReamrk");
                localStorage.removeItem("file");
                this.$router.push({
                  path: "/manuscriptList",
                });
              });
            }
          } else {
            this.$alert(res.message, "提示", {
              confirmButtonText: "确定",
            });
          }
        });
      }
    },
    // 重置
    resh() {
      this.$router.go(0);
    },
    async getUsers() {
      if (this.mediaType == "1") {
        var data = {
          username: localStorage.getItem("username"),
          mediaType: 1,
          priceStart: 0,
          priceEnd: 99999,
          fansStart: 0,
          fansEnd: 99999,
          readingStart: 0,
          readingEnd: 99999,
          friendsStart: 0,
          friendsEnd: 99999,
          index: this.index,
          size: this.size,
        };
        myAxios.post(`/client_user/Medias/v1`, data).then((res) => {
          this.tableData = res.data;
          for (var i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i].auth) {
              this.tableData[i].auth = "已认证";
            } else {
              this.tableData[i].auth = "未认证";
            }
            if (this.tableData[i].contactable) {
              this.tableData[i].contactable = "是";
            } else {
              this.tableData[i].contactable = "否";
            }
            if (this.tableData[i].linkable) {
              this.tableData[i].linkable = "是";
            } else {
              this.tableData[i].linkable = "否";
            }
          }
          this.count = res.total;
        });
      } else {
        var data2 = {
          username: localStorage.getItem("username"),
          mediaType: 2,
          priceStart: 0,
          priceEnd: 999999,
          fansStart: 0,
          fansEnd: 999999,
          readingStart: 0,
          readingEnd: 999999,
          friendsStart: 0,
          friendsEnd: 999999,
          index: this.index2,
          size: this.size,
        };
        myAxios.post(`/client_user/Medias/v1`, data2).then((res) => {
          this.tableData2 = res.data;
          for (var i = 0; i < this.tableData2.length; i++) {
            if (this.tableData2[i].auth) {
              this.tableData2[i].auth = "已认证";
            } else {
              this.tableData2[i].auth = "未认证";
            }
            if (this.tableData2[i].contactable) {
              this.tableData2[i].contactable = "是";
            } else {
              this.tableData2[i].contactable = "否";
            }
            if (this.tableData2[i].linkable) {
              this.tableData2[i].linkable = "是";
            } else {
              this.tableData2[i].linkable = "否";
            }
          }
          this.count2 = res.total;
        });
      }
      this.loading = false;
    },
    handleClick(tab, event) {
      this.mediaType = Number(tab.index) + 1;
      this.mediaType = this.mediaType + "";
      console.log(this.mediaType);
      if (this.mediaType == "1" || this.mediaType == "2") {
        this.getUsers();
      }
    },
    onCheckbox_menhu(val) {
      if (val[0] == "不限" && val.length > 1) {
        this.menhu.shift();
        console.log(this.menhu);
      }
    },
    onCheckbox_pindao(val) {
      if (val[0] == "不限" && val.length > 1) {
        this.pindao.shift();
        console.log(this.pindao);
      }
    },
    onCheckbox_other(val) {
      if (val[0] == "不限" && val.length > 1) {
        this.other.shift();
      }
    },
    onCheckbox_toufang(val) {
      if (val[0] == "不限" && val.length > 1) {
        this.toufang.shift();
        console.log(this.toufang);
      }
    },
    onCheckAll_toufang(val) {
      // console.log(val)
      if (val) {
        this.toufang = ["不限"];
      }
    },
    onCheckbox_toufang2(val) {
      if (val[0] == "不限" && val.length > 1) {
        this.toufang2.shift();
        console.log(this.toufang2);
      }
    },
    onCheckAll_toufang2(val) {
      // console.log(val)
      if (val) {
        this.toufang2 = ["不限"];
      }
    },
    onCheckAll_menhu(val) {
      // console.log(val)
      if (val) {
        this.menhu = ["不限"];
      }
    },
    onCheckAll_pindao(val) {
      // console.log(val)
      if (val) {
        this.pindao = ["不限"];
      }
    },
    onCheckAll_other(val) {
      // console.log(val)
      if (val) {
        this.other = ["不限"];
      }
    },
    onCheckbox_menhu2(val) {
      if (val[0] == "不限" && val.length > 1) {
        this.menhu2.shift();
        console.log(this.menhu2);
      }
    },
    onCheckbox_pindao2(val) {
      if (val[0] == "不限" && val.length > 1) {
        this.pindao2.shift();
        console.log(this.pindao2);
      }
    },
    onCheckAll_mtlx(val) {
      if (val[0] == "不限" && val.length > 1) {
        this.toufang2.shift();
      }
    },
    onCheckbox_other2(val) {
      if (val[0] == "不限" && val.length > 1) {
        this.other2.shift();
      }
    },
    onCheckAll_menhu2(val) {
      // console.log(val)
      if (val) {
        this.menhu2 = ["不限"];
      }
    },
    onCheckAll_pindao2(val) {
      // console.log(val)
      if (val) {
        this.pindao2 = ["不限"];
      }
    },
    onCheckAll_other2(val) {
      // console.log(val)
      if (val) {
        this.other2 = ["不限"];
      }
    },
  },
};
</script>

<style lang="less">
@import "../style/mixin";

.tipsBox {
  font-size: 12px;
  margin-top: 10px;
  font-weight: bold;
}

.btn_bottom {
  position: fixed;
  bottom: 5px;
  right: 50px;
}

.table_container {
  padding: 20px;
  position: relative;
}

.media-cell {
  position: relative;
  height: 30px;
  border-bottom-color: #eeeeee;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  margin-top: 10px;
}

.media-input {
  width: 200px;
  height: 10px;
  position: absolute;
  top: 0;
  left: 8%;
}

.media-p1 {
  position: absolute;
  top: 0;
  left: 28%;
}

.media-select {
  position: absolute;
  top: 0;
  left: 35%;
}

.media-p2 {
  position: absolute;
  top: 0;
  left: 55%;
}

.media-p3 {
  position: absolute;
  top: 0;
  left: 85%;
}

.media-select2 {
  position: absolute;
  top: 0;
  left: 65%;
}

.choose-bottom {
  position: fixed;
  bottom: 0;
  left: 16%;
  padding-left: 2%;
  background-color: aliceblue;
  height: auto;
  line-height: 50px;
  width: 82%;
  font-weight: bold;
  font-size: 10pt;
}

.yrz {
  color: #fd5353;
  border: 1px solid #fd5353;
  border-radius: 5px;
  font-size: 9pt;
  padding: 1px;
}

.wrz {
  background-color: #bdbdbd;
  color: #ffffff;
  border-radius: 5px;
  font-size: 9pt;
  padding: 1px;
}

.over_text {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
<style>
.cellBox {
  line-height: 30px;
  padding-right: 21px;
  overflow: hidden;
  position: relative;
}

.moreBox {
  position: absolute;
  bottom: 0;
  right: 20px;
  color: blue;
  font-size: 14px;
  cursor: pointer;
}

.media-cell .el-radio {
  margin-right: 15px;
}

.el-input-group__prepend {
  background: #fff !important;
}
</style>
